/**
 * Mobile Drawer User Info Component
 *
 * Displays user information in the mobile drawer header
 * including avatar, name, email, and user type badge.
 */

import React from "react";
import { User } from "lucide-react";

interface MobileDrawerUserInfoProps {
  appUser: {
    first_name?: string;
    last_name?: string;
    email?: string;
  } | null;
  getUserTypeDisplay: () => string;
  showUserInfo: boolean;
}

export function MobileDrawerUserInfo({
  appUser,
  getUserTypeDisplay,
  showUserInfo,
}: MobileDrawerUserInfoProps) {
  if (!showUserInfo || !appUser) {
    return null;
  }

  return (
    <div className="mb-4 pb-4 border-b border-gray-200 dark:border-gray-700">
      <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/40 rounded-full flex items-center justify-center">
          <User className="h-5 w-5 text-blue-600" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-card-foreground truncate">
            {appUser.first_name
              ? `${appUser.first_name} ${appUser.last_name || ""}`.trim()
              : appUser.email?.split("@")[0] || "User"}
          </p>
          <p className="text-xs text-gray-500 truncate">{appUser.email}</p>
          <span className="inline-block text-xs bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200 px-2 py-1 rounded mt-1">
            {getUserTypeDisplay()}
          </span>
        </div>
      </div>
    </div>
  );
}
